export enum ActionCardThemes {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  Darker = 'darker',
}
